import _ from '../../common/utility'

function adCOE() {
    if (_.isCOE()) {
        if (_.getBreakpoint() === 1) {
            const adconfig2 = {
                pos: '1521',
                id: '1521',
                targetElement: '122',
                beforeOrAfter: 'insertAfter'
            }

            const elem1521 = profads.ads2.insertAdElement(adconfig2);
            let parentWrapper = $('<div class="ads-1521-wrapper"> </div>');
            $(parentWrapper).append(elem1521);
            $(parentWrapper).insertAfter($("main section").eq(0));
        } else {
           const adconfig2 = {
                pos: '521',
                id: '521',
                targetElement: '122',
                beforeOrAfter: 'insertAfter'
            }

            const elem521 = profads.ads2.insertAdElement(adconfig2);
            let parentWrapper = $('<div class="ads-521-wrapper"> </div>');
            $(parentWrapper).append(elem521);
            $(parentWrapper).insertAfter($("main section").eq(0));
        }
    }
}

export default _.catch(adCOE);